import {
  RESETPASSWORD_REQUESTING,
  RESETPASSWORD_SUCCESS,
  RESETPASSWORD_ERROR,
} from './constants'

const initialState = {
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
}

const reducer = function resetPasswordReducer (state = initialState, action) {
  switch (action.type) {
    // Set the requesting flag and append a message to be shown
    case RESETPASSWORD_REQUESTING:
      return {
        ...state,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
      }

    // Successful?  Reset the login state.
    case RESETPASSWORD_SUCCESS: 
      return {
        ...state,
        errors: [],
        messages: [{ body: action.message, time: new Date() }],
        requesting: false,
        successful: true,
      }

    // Append the error returned from our api
    // set the success and requesting flags to false
    case RESETPASSWORD_ERROR:
      return {
        ...state,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
        messages: [],
        requesting: false,
        successful: false,
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPassword/reducer.js